import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Phone, Menu, X } from "lucide-react";
import Logo from "./Logo";
import { NAV, PHONE_TEL, PHONE_DISPLAY, CTA_TEXT } from "../data";

export default function Navbar({ transparentOnTop = false }) {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  useEffect(() => setOpen(false), [location.pathname, location.hash]);

  const solid = !transparentOnTop || scrolled || open;

  return (
    <>
      <header data-testid="navbar" className="fixed top-0 inset-x-0 z-50 transition-colors duration-500"
        style={{ background: solid ? "#172B38" : "transparent", borderBottom: solid ? "1px solid rgba(244,241,233,0.08)" : "1px solid transparent" }}>
        <div className={`wrap flex items-center justify-between transition-[padding] duration-500 ${solid ? "py-3" : "py-5 md:py-7"}`}>
          <Link to="/" data-testid="logo" aria-label="Honest Water LLC home"><Logo compact={solid} /></Link>

          <nav className="hidden lg:flex items-center gap-8 xl:gap-10" aria-label="Main">
            {NAV.map((n) => (
              <Link key={n.to} to={n.to} data-testid={`nav-${n.label.toLowerCase().replace(/ /g, "-")}`}
                className="text-[0.92rem] text-[#F4F1E9]/85 hover:text-[#F4F1E9] transition-colors">{n.label}</Link>
            ))}
          </nav>

          <div className="flex items-center gap-5">
            <span className="hidden xl:block w-px h-6 bg-[#F4F1E9]/30" />
            <a href={`tel:${PHONE_TEL}`} data-testid="navbar-call-link" className="hidden xl:flex items-center gap-2 text-[0.92rem] text-[#F4F1E9]/90 hover:text-[#F4F1E9]">
              <Phone className="w-4 h-4" strokeWidth={1.5} /> {PHONE_DISPLAY}
            </a>
            <span className="hidden md:block"><Link to="/#schedule" data-testid="navbar-quote-button" className="btn-cta !py-2.5 !px-5 !text-[0.88rem] !bg-[#172B38] !border-[#F4F1E9]/40 hover:!border-[#F4F1E9]">{CTA_TEXT}</Link></span>
            <button className="lg:hidden p-2 -mr-2 text-[#F4F1E9]" data-testid="nav-menu-toggle" onClick={() => setOpen((o) => !o)} aria-label="Open menu" aria-expanded={open}>
              {open ? <X className="w-6 h-6" strokeWidth={1.5} /> : <Menu className="w-6 h-6" strokeWidth={1.5} />}
            </button>
          </div>
        </div>

        {open && (
          <div className="lg:hidden border-t border-[#F4F1E9]/10 bg-[#172B38]" data-testid="mobile-menu">
            <div className="wrap py-6">
              {NAV.map((n) => (
                <Link key={n.to} to={n.to} className="block py-3 font-heading text-2xl text-[#F4F1E9] border-b border-[#F4F1E9]/10">{n.label}</Link>
              ))}
              <a href={`tel:${PHONE_TEL}`} className="flex items-center gap-2 py-4 text-[#8CAFC0]"><Phone className="w-4 h-4" /> {PHONE_DISPLAY}</a>
              <Link to="/#schedule" className="btn-light w-full mt-2">{CTA_TEXT}</Link>
            </div>
          </div>
        )}
      </header>
      {!transparentOnTop && <div className="h-[76px] bg-[#172B38]" aria-hidden="true" />}
    </>
  );
}
